module.exports = __webpack_public_path__ + "img/20200513_150604.d12f9fd0.jpg";